import { IMarkerV1 } from 'types/markerTypesV1/marker-v1-type.js';

export const getTextAlign = (pos?: IMarkerV1['labelPos']) => {
  if (pos) {
    if (['above', 'top', 'bottom', 'below'].includes(pos)) {
      return 'u-textCenter';
    }
    if (pos === 'left') {
      return 'u-textRight';
    }
    if (pos === 'right') {
      return 'u-textLeft';
    }
  }
  return undefined;
};
